import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../@core/services/authentication.service';
import { WebpagesService } from '../../@core/services/webpages.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'website-header',
  templateUrl: './website-header.component.html',
  styleUrls: ['./website-header.component.scss']
})
export class WebsiteHeaderComponent implements OnInit {

  constructor(
    public _webpagesService: WebpagesService,
    private translateService: TranslateService,
    private router : Router,
    public authenticationService: AuthenticationService,  ) { }

  ngOnInit() {
  }

  public translateClick(language:number) {
    this.authenticationService.updateLanguage = language;
    if(language == 1)
      this.translateService.use("fr");
    else
      this.translateService.use("en");

      this.router.navigateByUrl('/login', { skipLocationChange: true }).then(() => {
        this.router.navigate([this.router.url]);
    }); 
    //  this.router.navigateByUrl(this.router.url); 
  }
}
